<div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="30px">
  <button
    mat-dialog-close
    fxFlexAlign="end"
    type="button"
    mat-icon-button
  >
    <mat-icon>close</mat-icon>
  </button>

  <span>{{ "UPDATE_SAVING_PLAN_NAME" | translate }}</span>
  <mat-form-field appearance="outline" class="mrg-30">
    <mat-label>{{ "NAME" | translate }}</mat-label>
    <input [formControl]="nameControl" matInput [placeholder]="'NAME' | translate" />
  </mat-form-field>

  <button
    mat-flat-button
    color="primary"
    class="my-button"
    (click)="onUpdate()"
  >
    {{ "UPDATE" | translate }}
  </button>
</div>
